import React from "react";
import spinner from "../../assets/images/logo.png";

function LoadingPage({ identifier = "bigbox" }) {
  return (
    <div
      className="align-items-center bg-silver d-flex justify-content-center"
      style={{ height: "100vh" }}
    >
      {identifier == "technorama" ? (
        technoramaSvg()
      ) : (
        <img
          src={spinner}
          style={{ width: "150px", padding: "15px" }}
          alt="Loading..."
        />
      )}
    </div>
  );
}

export default LoadingPage;

const technoramaSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="e8jvan9oh7cl1"
    viewBox="-85 -58.750000 100 100"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    style={{ width: "100px", padding: "15px" }}
  >
    <defs>
      <clipPath id="e8jvan9oh7cl2">
        <use id="e8jvan9oh7cl3" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl4">
        <use id="e8jvan9oh7cl5" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl6">
        <use id="e8jvan9oh7cl7" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl8">
        <use id="e8jvan9oh7cl9" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl10">
        <use id="e8jvan9oh7cl11" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl12">
        <use id="e8jvan9oh7cl13" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl14">
        <use id="e8jvan9oh7cl15" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl16">
        <use id="e8jvan9oh7cl17" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl18">
        <use id="e8jvan9oh7cl19" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl20">
        <use id="e8jvan9oh7cl21" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl22">
        <use id="e8jvan9oh7cl23" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl24">
        <use id="e8jvan9oh7cl25" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl26">
        <use id="e8jvan9oh7cl27" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl28">
        <use id="e8jvan9oh7cl29" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl30">
        <use id="e8jvan9oh7cl31" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl32">
        <use id="e8jvan9oh7cl33" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl34">
        <use id="e8jvan9oh7cl35" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl36">
        <use id="e8jvan9oh7cl37" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl38">
        <use id="e8jvan9oh7cl39" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl40">
        <use id="e8jvan9oh7cl41" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl42">
        <use id="e8jvan9oh7cl43" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl44">
        <use id="e8jvan9oh7cl45" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl46">
        <use id="e8jvan9oh7cl47" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl48">
        <use id="e8jvan9oh7cl49" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl50">
        <use id="e8jvan9oh7cl51" width="629.723999" height="445.258972" />
      </clipPath>
      <clipPath id="e8jvan9oh7cl52">
        <use id="e8jvan9oh7cl53" width="629.723999" height="445.258972" />
      </clipPath>
    </defs>
    <g id="e8jvan9oh7cl54" display="none">
      <g id="e8jvan9oh7cl55">
        <g id="e8jvan9oh7cl56">
          <g id="e8jvan9oh7cl57">
            <path
              id="e8jvan9oh7cl58"
              d="M-120.413000,-21.200000C-116.532000,-22.509000,-112.363000,-22.127000,-108.367000,-21.442000C-107.794000,-21.345000,-106.653000,-21.134000,-106.653000,-21.134000L-107.603000,-15.429000C-107.603000,-15.429000,-108.820000,-15.617000,-109.432000,-15.702000C-111.660000,-16.013000,-113.909000,-16.209000,-116.150000,-16.036000C-117.686000,-15.970000,-119.046000,-14.727000,-119.061000,-13.158000C-119.227000,-10.525000,-119.086000,-7.881000,-119.135000,-5.245000C-119.087000,-3.508000,-119.298000,-1.725000,-118.855000,-0.024000C-118.453000,1.112000,-117.296000,1.766000,-116.133000,1.848000C-113.805000,2.049000,-111.475000,1.779000,-109.160000,1.471000C-108.635000,1.397000,-107.586000,1.257000,-107.586000,1.257000L-106.641000,6.954000C-106.641000,6.954000,-107.688000,7.145000,-108.217000,7.237000C-112.356000,7.942000,-116.703000,8.401000,-120.683000,6.888000C-123.737000,5.790000,-125.647000,2.643000,-125.647000,-0.533000C-125.665000,-5.069000,-125.716000,-9.597000,-125.622000,-14.128000C-125.504000,-17.273000,-123.408000,-20.187000,-120.413000,-21.200000"
              clipPath="url(#e8jvan9oh7cl2)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl59">
            <polygon
              id="e8jvan9oh7cl60"
              points="-174.046000,-21.631000 -151.861000,-21.631000 -151.871000,-15.814000 -159.723000,-15.814000 -159.723000,7.443000 -166.194000,7.443000 -166.181000,-15.814000 -174.038000,-15.814000"
              clipPath="url(#e8jvan9oh7cl4)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl61">
            <polygon
              id="e8jvan9oh7cl62"
              points="-148.114000,-21.633000 -129.821000,-21.631000 -129.826000,-15.814000 -141.557000,-15.814000 -141.557000,-10.257000 -130.743000,-10.257000 -130.743000,-4.473000 -141.557000,-4.473000 -141.557000,1.639000 -129.826000,1.639000 -129.826000,7.443000 -148.102000,7.443000"
              clipPath="url(#e8jvan9oh7cl6)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl63">
            <polygon
              id="e8jvan9oh7cl64"
              points="-101.959000,-21.631000 -95.407000,-21.631000 -95.407000,-10.048000 -86.027000,-10.048000 -86.027000,-21.631000 -79.476000,-21.631000 -79.482000,7.443000 -86.027000,7.443000 -86.027000,-4.256000 -95.407000,-4.256000 -95.407000,7.443000 -101.952000,7.443000"
              clipPath="url(#e8jvan9oh7cl8)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl65">
            <polygon
              id="e8jvan9oh7cl66"
              points="-73.410000,-21.631000 -65.411000,-21.631000 -55.827000,-1.305000 -55.825000,-21.631000 -49.557000,-21.631000 -49.577000,7.443000 -57.666000,7.436000 -67.211000,-11.938000 -67.255000,7.443000 -73.400000,7.443000"
              clipPath="url(#e8jvan9oh7cl10)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl67">
            <path
              id="e8jvan9oh7cl68"
              d="M-5.590000,-21.625000C-1.197000,-21.589000,3.568000,-21.658000,7.961000,-21.594000C10.205000,-21.467000,12.359000,-21.039000,14.068000,-19.483000C15.632000,-18.054000,16.159000,-15.283000,16.177000,-13.870000C16.190000,-12.362000,16.218000,-11.917000,16.177000,-10.213000C16.177000,-7.238000,14.453000,-4.182000,11.723000,-3.062000C11.766000,-2.981000,11.853000,-2.812000,11.853000,-2.812000L17.359000,7.441000L9.844000,7.441000L4.672000,-2.359000L0.964000,-2.369000L0.964000,7.441000L-5.579000,7.441000C-5.579000,-3.029000,-5.569000,-12.722000,-5.590000,-21.625000M0.966000,-15.814000L0.966000,-7.868000C0.966000,-7.868000,6.401000,-7.873000,7.611000,-7.873000C8.823000,-7.873000,9.506000,-8.884000,9.549000,-10.005000C9.661000,-11.390000,9.692000,-12.256000,9.580000,-13.647000C9.552000,-14.801000,9.053000,-15.817000,7.392000,-15.817000L0.966000,-15.817000L0.966000,-15.814000Z"
              clipPath="url(#e8jvan9oh7cl12)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl69">
            <path
              id="e8jvan9oh7cl70"
              d="M28.237000,-21.631000L37,-21.631000L45.873000,7.435000L39.071000,7.440000L37.500000,1.753000L27.792000,1.766000L26.216000,7.443000L19.363000,7.433000L28.237000,-21.631000ZM29.240000,-3.689000L35.892000,-3.689000L32.589000,-15.801000L29.240000,-3.689000Z"
              clipPath="url(#e8jvan9oh7cl14)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl71">
            <path
              id="e8jvan9oh7cl72"
              d="M92.993000,-21.623000L101.759000,-21.626000L110.632000,7.433000L103.824000,7.438000L102.258000,1.751000L92.545000,1.764000L90.974000,7.438000L84.121000,7.428000L92.993000,-21.623000ZM93.997000,-3.689000L100.652000,-3.689000L97.351000,-15.801000L93.997000,-3.689000Z"
              clipPath="url(#e8jvan9oh7cl16)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl73">
            <path
              id="e8jvan9oh7cl74"
              d="M-27.563000,10.023000C-32.137000,10.023000,-36.436000,8.243000,-39.673000,5.008000C-42.902000,1.776000,-44.685000,-2.520000,-44.685000,-7.094000C-44.685000,-11.665000,-42.902000,-15.964000,-39.673000,-19.199000C-38.428000,-20.442000,-36.411000,-20.442000,-35.170000,-19.199000C-33.927000,-17.956000,-33.927000,-15.942000,-35.170000,-14.699000C-37.205000,-12.667000,-38.320000,-9.967000,-38.320000,-7.094000C-38.320000,-4.219000,-37.202000,-1.519000,-35.170000,0.511000C-33.140000,2.543000,-30.438000,3.659000,-27.565000,3.659000C-24.695000,3.659000,-21.995000,2.544000,-19.963000,0.511000C-17.933000,-1.519000,-16.813000,-4.218000,-16.813000,-7.094000C-16.813000,-9.967000,-17.934000,-12.666000,-19.963000,-14.699000C-21.206000,-15.942000,-21.206000,-17.956000,-19.963000,-19.199000C-18.720000,-20.442000,-16.706000,-20.442000,-15.463000,-19.199000C-12.229000,-15.967000,-10.448000,-11.666000,-10.448000,-7.094000C-10.448000,-2.520000,-12.228000,1.776000,-15.463000,5.008000C-18.695000,8.243000,-22.992000,10.023000,-27.563000,10.023000"
              clipPath="url(#e8jvan9oh7cl18)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl75">
            <path
              id="e8jvan9oh7cl76"
              d="M-27.566000,-3.915000C-29.323000,-3.915000,-30.749000,-5.336000,-30.749000,-7.096000L-30.749000,-20.971000C-30.749000,-22.731000,-29.323000,-24.152000,-27.566000,-24.152000C-25.811000,-24.152000,-24.385000,-22.731000,-24.385000,-20.971000L-24.385000,-7.096000C-24.385000,-5.339000,-25.808000,-3.915000,-27.566000,-3.915000"
              clipPath="url(#e8jvan9oh7cl20)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl77">
            <path
              id="e8jvan9oh7cl78"
              d="M-27.469000,-35.019000C-19.424000,-35.019000,-12.186000,-31.624000,-7.059000,-26.207000L-0.842000,-31.912000C-7.504000,-39.030000,-16.981000,-43.485000,-27.496000,-43.485000C-38.014000,-43.485000,-47.488000,-39.031000,-54.148000,-31.912000L-47.901000,-26.177000C-42.775000,-31.611000,-35.527000,-35.019000,-27.469000,-35.019000"
              clipPath="url(#e8jvan9oh7cl22)"
              fill="rgb(229,53,38)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl79">
            <path
              id="e8jvan9oh7cl80"
              d="M-27.525000,21.155000C-35.570000,21.155000,-42.806000,17.760000,-47.932000,12.343000L-54.151000,18.050000C-47.486000,25.168000,-38.015000,29.623000,-27.497000,29.623000C-16.979000,29.623000,-7.505000,25.169000,-0.843000,18.050000L-7.090000,12.315000C-12.219000,17.748000,-19.464000,21.155000,-27.525000,21.155000"
              clipPath="url(#e8jvan9oh7cl24)"
              fill="rgb(242,147,32)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl81">
            <polygon
              id="e8jvan9oh7cl82"
              points="80.647000,-21.631000 72.487000,-21.631000 64.997000,-3.352000 57.504000,-21.631000 49.347000,-21.631000 49.347000,7.431000 55.650000,7.436000 55.660000,-11.028000 62.218000,4.930000 67.775000,4.930000 74.333000,-11.028000 74.353000,7.436000 80.659000,7.431000"
              clipPath="url(#e8jvan9oh7cl26)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl83">
            <path
              id="e8jvan9oh7cl84"
              d="M-120.413000,-21.200000C-116.532000,-22.509000,-112.363000,-22.127000,-108.367000,-21.442000C-107.794000,-21.345000,-106.653000,-21.134000,-106.653000,-21.134000L-107.603000,-15.429000C-107.603000,-15.429000,-108.820000,-15.617000,-109.432000,-15.702000C-111.660000,-16.013000,-113.909000,-16.209000,-116.150000,-16.036000C-117.686000,-15.970000,-119.046000,-14.727000,-119.061000,-13.158000C-119.227000,-10.525000,-119.086000,-7.881000,-119.135000,-5.245000C-119.087000,-3.508000,-119.298000,-1.725000,-118.855000,-0.024000C-118.453000,1.112000,-117.296000,1.766000,-116.133000,1.848000C-113.805000,2.049000,-111.475000,1.779000,-109.160000,1.471000C-108.635000,1.397000,-107.586000,1.257000,-107.586000,1.257000L-106.641000,6.954000C-106.641000,6.954000,-107.688000,7.145000,-108.217000,7.237000C-112.356000,7.942000,-116.703000,8.401000,-120.683000,6.888000C-123.737000,5.790000,-125.647000,2.643000,-125.647000,-0.533000C-125.665000,-5.069000,-125.716000,-9.597000,-125.622000,-14.128000C-125.504000,-17.273000,-123.408000,-20.187000,-120.413000,-21.200000"
              clipPath="url(#e8jvan9oh7cl28)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl85">
            <polygon
              id="e8jvan9oh7cl86"
              points="-174.046000,-21.631000 -151.861000,-21.631000 -151.871000,-15.814000 -159.723000,-15.814000 -159.723000,7.443000 -166.194000,7.443000 -166.181000,-15.814000 -174.038000,-15.814000"
              clipPath="url(#e8jvan9oh7cl30)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl87">
            <polygon
              id="e8jvan9oh7cl88"
              points="-148.114000,-21.633000 -129.821000,-21.631000 -129.826000,-15.814000 -141.557000,-15.814000 -141.557000,-10.257000 -130.743000,-10.257000 -130.743000,-4.473000 -141.557000,-4.473000 -141.557000,1.639000 -129.826000,1.639000 -129.826000,7.443000 -148.102000,7.443000"
              clipPath="url(#e8jvan9oh7cl32)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl89">
            <polygon
              id="e8jvan9oh7cl90"
              points="-101.959000,-21.631000 -95.407000,-21.631000 -95.407000,-10.048000 -86.027000,-10.048000 -86.027000,-21.631000 -79.476000,-21.631000 -79.482000,7.443000 -86.027000,7.443000 -86.027000,-4.256000 -95.407000,-4.256000 -95.407000,7.443000 -101.952000,7.443000"
              clipPath="url(#e8jvan9oh7cl34)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl91">
            <polygon
              id="e8jvan9oh7cl92"
              points="-73.410000,-21.631000 -65.411000,-21.631000 -55.827000,-1.305000 -55.825000,-21.631000 -49.557000,-21.631000 -49.577000,7.443000 -57.666000,7.436000 -67.211000,-11.938000 -67.255000,7.443000 -73.400000,7.443000"
              clipPath="url(#e8jvan9oh7cl36)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl93">
            <path
              id="e8jvan9oh7cl94"
              d="M-5.590000,-21.625000C-1.197000,-21.589000,3.568000,-21.658000,7.961000,-21.594000C10.205000,-21.467000,12.359000,-21.039000,14.068000,-19.483000C15.632000,-18.054000,16.159000,-15.283000,16.177000,-13.870000C16.190000,-12.362000,16.218000,-11.917000,16.177000,-10.213000C16.177000,-7.238000,14.453000,-4.182000,11.723000,-3.062000C11.766000,-2.981000,11.853000,-2.812000,11.853000,-2.812000L17.359000,7.441000L9.844000,7.441000L4.672000,-2.359000L0.964000,-2.369000L0.964000,7.441000L-5.579000,7.441000C-5.579000,-3.029000,-5.569000,-12.722000,-5.590000,-21.625000M0.966000,-15.814000L0.966000,-7.868000C0.966000,-7.868000,6.401000,-7.873000,7.611000,-7.873000C8.823000,-7.873000,9.506000,-8.884000,9.549000,-10.005000C9.661000,-11.390000,9.692000,-12.256000,9.580000,-13.647000C9.552000,-14.801000,9.053000,-15.817000,7.392000,-15.817000L0.966000,-15.817000L0.966000,-15.814000Z"
              clipPath="url(#e8jvan9oh7cl38)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl95">
            <path
              id="e8jvan9oh7cl96"
              d="M28.237000,-21.631000L37,-21.631000L45.873000,7.435000L39.071000,7.440000L37.500000,1.753000L27.792000,1.766000L26.216000,7.443000L19.363000,7.433000L28.237000,-21.631000ZM29.240000,-3.689000L35.892000,-3.689000L32.589000,-15.801000L29.240000,-3.689000Z"
              clipPath="url(#e8jvan9oh7cl40)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl97">
            <path
              id="e8jvan9oh7cl98"
              d="M92.993000,-21.623000L101.759000,-21.626000L110.632000,7.433000L103.824000,7.438000L102.258000,1.751000L92.545000,1.764000L90.974000,7.438000L84.121000,7.428000L92.993000,-21.623000ZM93.997000,-3.689000L100.652000,-3.689000L97.351000,-15.801000L93.997000,-3.689000Z"
              clipPath="url(#e8jvan9oh7cl42)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl99">
            <path
              id="e8jvan9oh7cl100"
              d="M-27.563000,10.023000C-32.137000,10.023000,-36.436000,8.243000,-39.673000,5.008000C-42.902000,1.776000,-44.685000,-2.520000,-44.685000,-7.094000C-44.685000,-11.665000,-42.902000,-15.964000,-39.673000,-19.199000C-38.428000,-20.442000,-36.411000,-20.442000,-35.170000,-19.199000C-33.927000,-17.956000,-33.927000,-15.942000,-35.170000,-14.699000C-37.205000,-12.667000,-38.320000,-9.967000,-38.320000,-7.094000C-38.320000,-4.219000,-37.202000,-1.519000,-35.170000,0.511000C-33.140000,2.543000,-30.438000,3.659000,-27.565000,3.659000C-24.695000,3.659000,-21.995000,2.544000,-19.963000,0.511000C-17.933000,-1.519000,-16.813000,-4.218000,-16.813000,-7.094000C-16.813000,-9.967000,-17.934000,-12.666000,-19.963000,-14.699000C-21.206000,-15.942000,-21.206000,-17.956000,-19.963000,-19.199000C-18.720000,-20.442000,-16.706000,-20.442000,-15.463000,-19.199000C-12.229000,-15.967000,-10.448000,-11.666000,-10.448000,-7.094000C-10.448000,-2.520000,-12.228000,1.776000,-15.463000,5.008000C-18.695000,8.243000,-22.992000,10.023000,-27.563000,10.023000"
              clipPath="url(#e8jvan9oh7cl44)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl101">
            <path
              id="e8jvan9oh7cl102"
              d="M-27.566000,-3.915000C-29.323000,-3.915000,-30.749000,-5.336000,-30.749000,-7.096000L-30.749000,-20.971000C-30.749000,-22.731000,-29.323000,-24.152000,-27.566000,-24.152000C-25.811000,-24.152000,-24.385000,-22.731000,-24.385000,-20.971000L-24.385000,-7.096000C-24.385000,-5.339000,-25.808000,-3.915000,-27.566000,-3.915000"
              clipPath="url(#e8jvan9oh7cl46)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl103">
            <path
              id="e8jvan9oh7cl104"
              d="M-27.469000,-35.019000C-19.424000,-35.019000,-12.186000,-31.624000,-7.059000,-26.207000L-0.842000,-31.912000C-7.504000,-39.030000,-16.981000,-43.485000,-27.496000,-43.485000C-38.014000,-43.485000,-47.488000,-39.031000,-54.148000,-31.912000L-47.901000,-26.177000C-42.775000,-31.611000,-35.527000,-35.019000,-27.469000,-35.019000"
              clipPath="url(#e8jvan9oh7cl48)"
              fill="rgb(229,53,38)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl105">
            <path
              id="e8jvan9oh7cl106"
              d="M-27.525000,21.155000C-35.570000,21.155000,-42.806000,17.760000,-47.932000,12.343000L-54.151000,18.050000C-47.486000,25.168000,-38.015000,29.623000,-27.497000,29.623000C-16.979000,29.623000,-7.505000,25.169000,-0.843000,18.050000L-7.090000,12.315000C-12.219000,17.748000,-19.464000,21.155000,-27.525000,21.155000"
              clipPath="url(#e8jvan9oh7cl50)"
              fill="rgb(242,147,32)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
          <g id="e8jvan9oh7cl107">
            <polygon
              id="e8jvan9oh7cl108"
              points="80.647000,-21.631000 72.487000,-21.631000 64.997000,-3.352000 57.504000,-21.631000 49.347000,-21.631000 49.347000,7.431000 55.650000,7.436000 55.660000,-11.028000 62.218000,4.930000 67.775000,4.930000 74.333000,-11.028000 74.353000,7.436000 80.659000,7.431000"
              clipPath="url(#e8jvan9oh7cl52)"
              fill="rgb(43,42,41)"
              stroke="none"
              strokeWidth="1"
            />
          </g>
        </g>
      </g>
    </g>
    <g id="e8jvan9oh7cl109">
      <path
        id="e8jvan9oh7cl110"
        d="M-34.794000,-5.324000C-36.930000,-5.324000,-38.664000,-7.052000,-38.664000,-9.191000L-38.664000,-26.058000C-38.664000,-28.197000,-36.930000,-29.925000,-34.794000,-29.925000C-32.661000,-29.925000,-30.927000,-28.197000,-30.927000,-26.058000L-30.927000,-9.191000C-30.927000,-7.054000,-32.658000,-5.324000,-34.794000,-5.324000"
        fill="rgb(43,42,41)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="e8jvan9oh7cl111"
        d="M-34.791000,11.659000C-40.351000,11.659000,-45.577000,9.495000,-49.512000,5.563000C-53.438000,1.634000,-55.605000,-3.589000,-55.605000,-9.149000C-55.605000,-14.706000,-53.438000,-19.932000,-49.512000,-23.864000C-47.998000,-25.375000,-45.546000,-25.375000,-44.038000,-23.864000C-42.527000,-22.353000,-42.527000,-19.904000,-44.038000,-18.393000C-46.512000,-15.922000,-47.868000,-12.641000,-47.868000,-9.148000C-47.868000,-5.653000,-46.509000,-2.371000,-44.038000,0.097000C-41.571000,2.568000,-38.286000,3.924000,-34.793000,3.924000C-31.304000,3.924000,-28.022000,2.568000,-25.551000,0.097000C-23.084000,-2.370000,-21.721000,-5.652000,-21.721000,-9.148000C-21.721000,-12.640000,-23.083000,-15.922000,-25.551000,-18.393000C-27.062000,-19.904000,-27.062000,-22.353000,-25.551000,-23.864000C-24.040000,-25.375000,-21.591000,-25.375000,-20.080000,-23.864000C-16.148000,-19.935000,-13.984000,-14.706000,-13.984000,-9.149000C-13.984000,-3.589000,-16.148000,1.634000,-20.080000,5.563000C-24.010000,9.495000,-29.233000,11.659000,-34.791000,11.659000"
        fill="rgb(43,42,41)"
        stroke="none"
        strokeWidth="1"
      />
      <g id="e8jvan9oh7cl112_tr" transform="translate(-35,-8.750000) rotate(0)">
        <path
          id="e8jvan9oh7cl112"
          d="M-34.829000,25.039000C-44.609000,25.039000,-53.405000,20.912000,-59.637000,14.327000L-67.197000,21.265000C-59.095000,29.918000,-47.581000,35.333000,-34.794000,35.333000C-22.007000,35.333000,-10.491000,29.918000,-2.391000,21.265000L-9.985000,14.293000C-16.223000,20.897000,-25.031000,25.039000,-34.829000,25.039000"
          transform="translate(35,8.750000)"
          fill="rgb(242,147,32)"
          stroke="none"
          strokeWidth="1"
        />
      </g>
      <g id="e8jvan9oh7cl113_tr" transform="translate(-35,-8.750000) rotate(0)">
        <path
          id="e8jvan9oh7cl113"
          d="M-34.763000,-43.268000C-24.983000,-43.268000,-16.184000,-39.141000,-9.952000,-32.556000L-2.395000,-39.491000C-10.494000,-48.144000,-22.014000,-53.559000,-34.798000,-53.559000C-47.584000,-53.559000,-59.101000,-48.144000,-67.197000,-39.491000L-59.603000,-32.519000C-53.370000,-39.125000,-44.559000,-43.268000,-34.763000,-43.268000"
          transform="translate(35,8.750000)"
          fill="rgb(229,53,38)"
          stroke="none"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);
